import { ModalV2 } from "@/components";
import { useSnackbar } from "@/hooks";
import { Stack, TextField, Typography } from "@mui/material";
import { FC, useState, ReactElement } from "react";

const ContactVendor: FC<ContactVendorProps> = ({
  open,
  onClose,
  manufacturerName,
  manufacturerId,
  tenantId,
  userClientId,
  sendFirstSaleEmail,
  isSending,
  onRefetch,
}): ReactElement => {
  const [email, setEmail] = useState("");
  const { show } = useSnackbar();

  const handleSend = async () => {
    try {
      const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
      // Validate email before sending
      if (!emailRegex.test(email)) {
        show(
          "Invalid email address",
          "Please enter a valid email address",
          "error"
        );
        return;
      }

      if (!manufacturerId || !userClientId) {
        show(
          "Missing required information",
          "Manufacturer ID or Client ID is missing",
          "error"
        );
        return;
      }

      // Send email with required variables
      await sendFirstSaleEmail({
        manufacturerId,
        to: email.trim(),
        clientId: userClientId,
        ...(tenantId && { tenantId: tenantId }),
      });

      show("Email sent successfully", "Email sent successfully", "success");
      setEmail("");
      onClose();

      // Call refetch after successful email sending
      if (onRefetch) {
        onRefetch();
      }
    } catch (err) {
      console.error("Failed to send email:", err);
      show("Failed to send email", "Please try again", "error");
    }
  };

  const handleClose = () => {
    setEmail("");
    onClose();
  };

  return (
    <ModalV2
      show={open}
      setShow={handleClose}
      buttonText={"Send Request"}
    
      maxWidth="sm"
      buttonLoader={isSending}
      buttonAction={handleSend}
      title="Contact Vendor"
    >
      <Stack spacing={3} sx={{ my: 2 }}>
        <Typography variant="body1">
          Send first sale documentation request to{" "}
          <strong>
            {manufacturerName || manufacturerId ? (
              <>
                {manufacturerName} ({manufacturerId})
              </>
            ) : (
              "N/A"
            )}
          </strong>
        </Typography>

        <Stack spacing={1}>
          <Typography variant="body2" fontWeight={500}>
            Email Address
          </Typography>
          <TextField
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="vendor@example.com"
            fullWidth
          />
        </Stack>

        <Typography fontSize={14} color="text.secondary" mt="14px !important">
          We'll send an email with the necessary forms and instructions for the
          first sale documentation.
        </Typography>
      </Stack>
    </ModalV2>
  );
};

export default ContactVendor;
